interface HeadRowProp {
  cellClassName?: string | undefined;
}

export const BudgetEmptyRow: React.FC<HeadRowProp> = ({ cellClassName }: HeadRowProp) => {
  return (
    <tr>
      <td colSpan={7} className={cellClassName} />
    </tr>
  );
};
